import { render, staticRenderFns } from "./TipOnDevice.vue?vue&type=template&id=c764d8d4"
import script from "./TipOnDevice.vue?vue&type=script&lang=js"
export * from "./TipOnDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports